export default "__VITE_ASSET__DWMyt5uw__"